export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000004D',
        color: '#000000C4',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1010EB',
      },
      '&.Mui-error': {
        borderColor: '#e40a1a',
        backgroundColor: '#ffefee',

        '& input:-webkit-autofill': {
          WebkitTextFillColor: '#000000C4',
        },
      },
      '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#e40a1a',
      },
      '&.Mui-disabled': {
        backgroundColor: '#dcdcdc',
        color: '#000000C4',
      },
    },
    input: {
      '&.Mui-disabled': {
        WebkitTextFillColor: 'inherit',
      },
      '&::placeholder': {
        opacity: 1,
        color: '#0000008C',
      },
    },
  },
};
